define('OutSystems/ClientRuntime/modules/Database/WebSQL/Upgrader/WebSQLMetadataV2UpgraderStep2',["require", "exports", "tslib", "../../Metadata/MetadataBackupTableInfo", "../../Metadata/MetadataTableInfo", "./V0/MetadataBackupTableInfo", "./V0/MetadataTableInfo", "./WebSQLMetadataConverter", "./WebSQLMetadataV2Upgrader"], function (require, exports, tslib_1, MetadataBackupTableInfo_1, MetadataTableInfo_1, MetadataBackupTableInfo_2, MetadataTableInfo_2, WebSQLMetadataConverter_1, WebSQLMetadataV2Upgrader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WebSQLMetadataV2UpgraderStep2 = (function () {
        function WebSQLMetadataV2UpgraderStep2() {
            WebSQLMetadataV2UpgraderStep2.lastUpgraderRegistered = this;
        }
        WebSQLMetadataV2UpgraderStep2.prototype.isNeeded = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var result;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            result = false;
                            if (!(WebSQLMetadataV2UpgraderStep2.lastUpgraderRegistered === this)) return [3, 2];
                            return [4, WebSQLMetadataV2Upgrader_1.default.isNeeded(transaction)];
                        case 1:
                            result = _a.sent();
                            _a.label = 2;
                        case 2: return [2, result];
                    }
                });
            });
        };
        WebSQLMetadataV2UpgraderStep2.prototype.run = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var migrations;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            migrations = [
                                {
                                    v2TableInfo: MetadataTableInfo_1.default,
                                    v0TableInfo: MetadataTableInfo_2.default,
                                },
                                {
                                    v2TableInfo: MetadataBackupTableInfo_1.default,
                                    v0TableInfo: MetadataBackupTableInfo_2.default,
                                },
                            ].map(function (_a) {
                                var v2TableInfo = _a.v2TableInfo, v0TableInfo = _a.v0TableInfo;
                                return _this.migrateToV0(transaction, v2TableInfo, v0TableInfo);
                            });
                            return [4, Promise.all(migrations)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        WebSQLMetadataV2UpgraderStep2.prototype.migrateToV0 = function (transaction, v2TableInfo, v0TableInfo) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var records, newRecords;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getAllRecords(v2TableInfo)];
                        case 1:
                            records = (_a.sent());
                            newRecords = records.map(function (record) { return WebSQLMetadataConverter_1.convertV2ToV0(record); });
                            return [4, transaction.deleteTableIfExists(v2TableInfo.tableName + "_V2")];
                        case 2:
                            _a.sent();
                            return [4, transaction.renameTable(v2TableInfo.tableName, v2TableInfo.tableName + "_V2")];
                        case 3:
                            _a.sent();
                            return [4, transaction.createTable(v0TableInfo)];
                        case 4:
                            _a.sent();
                            return [4, transaction.upsertAllRecords(v0TableInfo, newRecords)];
                        case 5:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        WebSQLMetadataV2UpgraderStep2.prototype.cleanup = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    WebSQLMetadataV2UpgraderStep2.lastUpgraderRegistered = null;
                    return [2];
                });
            });
        };
        return WebSQLMetadataV2UpgraderStep2;
    }());
    exports.default = WebSQLMetadataV2UpgraderStep2;
});
//# sourceMappingURL=WebSQLMetadataV2UpgraderStep2.js.map;
